import React, {useCallback} from "react";
import styled from "styled-components";
import {InvestmentChange} from "./InvestmentChange";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {hideNotifications} from "../../notification/notificationActions";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const PortfolioName = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
`;

const FailureMessage = styled.div`
    color: ${({severity}) => severity === "failed" ? "#bd2d2d" : "#d8964d"};
    font-size: 12px;
    line-height: 22px;
    width: 430px;
    flex-shrink: 0;
    overflow-wrap: break-word;
`;

const SuggestedAction = styled.span`
    font-size: 12px;
`;

const PortfolioLink = styled(Link)`
    color: #3b7433;
    font-size: 12px;
`;

export const IdeaPortfolioUpdateOutcome = ({outcome: {portfolioId, portfolioName, previousInvestment, updatedInvestment, investmentPercentChange, failureMessage, suggestion}, severity}) => {
    const imeUserId = useSelector(state => state.userIdentity.imeUserId);
    const dispatch = useDispatch();
    const doHideNotifications = useCallback(() => {
        dispatch(hideNotifications());
    }, [dispatch]);
    return (
        <Container className="t-portfolio-update-outcome">
            <PortfolioName className="t-portfolio-name">
                {portfolioName}
            </PortfolioName>
            <InvestmentChange amountBefore={previousInvestment}
                              amountAfter={updatedInvestment}
                              actualUpdatePercent={investmentPercentChange}/>
            {
                failureMessage ? <FailureMessage className="t-failure-message" severity={severity}>{failureMessage}</FailureMessage>
                    : null
            }
            {
                suggestion ? <SuggestedAction>You can close {suggestion} ideas <PortfolioLink onClick={doHideNotifications} to={`/contribute/${portfolioId}/${imeUserId}`}>on this portfolio</PortfolioLink> to free up capital</SuggestedAction>
                    : null
            }
        </Container>
    );
};
